import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


import { tyroCancelTransaction } from '../../actions';


class TyroModalButtonGroup extends Component {
  render() {
    const { children, tyroCancelTransaction } = this.props;

    return (
      <div>
        <div className="ui fitted divider"></div>
        <div className="ui right aligned basic segment marginless paddingless">
          <div className="ui left floated basic negative button" onClick={tyroCancelTransaction}>Cancel</div>
          {children}
        </div>
      </div>
    );
  }
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    tyroCancelTransaction
  }, dispatch);
}


export default connect(null, mapDispatchToProps)(TyroModalButtonGroup);